import React from 'react';
import { Handler } from 'ml-component-web';

export default class PressHandler extends Handler {
    render() {
        return (
            <div className="page-content container">
                <h1>Press</h1>
                <p>
                	Thank you for your interest in MyBabyBio, the Online Baby Diary.  If you have any questions, or to request interviews, please contact us on: <a href="mailto:press@mybabybio.com">press@mybabybio.com</a>
                </p>
                <p>
                	<a href="https://www.dropbox.com/sh/lcyty9h8k3jw7p6/AABh3mURRN9OVM5ELk9zQzjLa?dl=0" className="btn contact">View Press Kit</a>
                </p>
                <p>
                	The Press Kit currently includes logos and app icons.  It will be updated soon to include press releases, product images and screenshots.
                </p>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/PressHandler.js
 **/